import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'

import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'

import ViewInPortraitMode from 'aria-viewer/tour/components/landscape/ViewInPortraitMode'
import LandscapeView from 'aria-viewer/tour/components/landscape/LandscapeView'

import IframeModal from 'aria-viewer/common/components/IframeModal'
import { setTourLoadingStatus } from 'aria-viewer/tour/tourActions'
import { setRegistrationEnabled } from 'aria-viewer/tour/tourActions'
import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'
import { closeModal } from 'aria-viewer/modal/modalActions'
import { getEnv } from 'aria-viewer/utils/environment'

const withLandScapeNoRender = WrappedComponent => ({ disableLandscape, isLandscape, isRegistrationOpen, ...props }) => {
    // Disables Landscape.  Could also move InquiryFormModal into RegsitrationWrapper to make more DRY
    const disableLandscapeFlag = disableLandscape && isRegistrationOpen && isLandscape

    return disableLandscapeFlag ? (
        <LandscapeView zIndex={2005}>
            <ViewInPortraitMode message="Please rotate your device into portrait mode to continue" />
        </LandscapeView>
    ) : (
        <WrappedComponent isRegistrationOpen={isRegistrationOpen} {...props} />
    )
}

/**
 * Content Iniquiry Form Modal
 * @param {*} param
 */
const InquiryFormModal = ({
    isRegistrationOpen,
    onClose,
    closeModal,
    setTourLoadingStatus,
    setRegistrationEnabled,
    userkey,
    isCIFForm,
    tour,
    location,
    embed,
    hasBorder,
}) => {
    return isRegistrationOpen ? (
        <IframeModal
            onClose={(completed = false) => {
                closeModal()
                setTourLoadingStatus(false)
                if (!isCIFForm || completed) {
                    setRegistrationEnabled(false)
                }
                onClose(completed)
            }}
            uriParams={{
                inst_id: location.owner_id,
                loc_id: location.loc_id,
                tourid: tour.tourid,
                userkey: userkey,
                embed: embed,
            }}
            hasBorder={hasBorder}
            src={getEnv('REACT_APP_CONTENT_INQUIRY_FORM_URL')}
        />
    ) : null
}

InquiryFormModal.defaultProps = {
    embed: 1,
    hasBorder: false,
    disableLandscape: false,
    isCIFForm: true, //InquiryFormModal is always CIF
    onClose: completed => {},
}

InquiryFormModal.propTypes = {
    embed: PropTypes.number,
    hasBorder: PropTypes.bool,
    isCIFForm: PropTypes.bool,
    disableLandscape: PropTypes.bool,
    onClose: PropTypes.func,
}

export default compose(
    connect(state => ({
        isLandscape: state.getIn(['device', 'isLandscape']),
        isRegistrationOpen: state
            .getIn(['modal', 'modalStack'])
            .some(modal =>
                [ModalContentTypes.WELCOME_REGISTRATION, ModalContentTypes.REGISTRATION].includes(modal.content.type)
            ),
        userkey: state.getIn(['analytics', 'userkey']),
    })),
    connect(
        mapSelectorsToProps(['tour', 'location']),
        {
            closeModal,
            setRegistrationEnabled,
            setTourLoadingStatus,
        }
    ),
    withLandScapeNoRender
)(InquiryFormModal)
